/* eslint-disable react/prop-types */

import React, { useContext, useEffect, useState } from "react";
import { PropTypes } from "prop-types";
import { Link } from "gatsby";
import { AppContext } from "~context/AppContext";
import { DocumentContext } from "~context/DocumentContext";
import Button from "~components/Button";
import Logo from "~components/svg/Logo";

const Header = () => {
  const {
    aLaCarte,
    bundles,
    monogamyPlan,
    setCartActive,
    headerHelper,
    mobileMenuOpen,
    setMobileMenuOpen,
    pathname,
    headerBgColor,
    setHeaderBgColor,
    headerFgColor,
    setHeaderFgColor,
    headerButtonColor,
    setHeaderButtonColor,
    headerHovered,
    setHeaderHovered,
    navigating,
    cartActive
  } = useContext(AppContext);
  const { scrollTop, windowWidth } = useContext(DocumentContext);
  const [lastHeaderHelper, setLastHeaderHelper] = useState(headerHelper);

  const cartLength = aLaCarte.length + bundles.length + (monogamyPlan ? 1 : 0);

  //

  useEffect(() => {
    if (headerHelper !== lastHeaderHelper) {
      setLastHeaderHelper(headerHelper);
    }
  }, [headerHelper]);

  //

  useEffect(() => {
    if (pathname?.includes(`case-studies`)) return;

    if (pathname === `/experiments` || pathname === `/experiments/`) {
      setHeaderBgColor(`orange`);
      setHeaderFgColor(`off-white`);
      setHeaderButtonColor({ background: `white`, text: `orange` });
    } else {
      setHeaderBgColor(`sauvignon`);
      setHeaderFgColor(`orange`);
      setHeaderButtonColor({ background: `orange`, text: `white` });
    }
  }, [pathname]);

  useEffect(() => {
    if (pathname?.includes(`case-studies`)) return;

    if (!mobileMenuOpen) {
      if (pathname === `/experiments` || pathname === `/experiments/`) {
        setHeaderBgColor(`orange`);
        setHeaderFgColor(`off-white`);
        setHeaderButtonColor({ background: `white`, text: `orange` });
      } else {
        setHeaderBgColor(`sauvignon`);
        setHeaderFgColor(`orange`);
        setHeaderButtonColor({ background: `orange`, text: `white` });
      }
    } else {
      setHeaderBgColor(`navy`);
      setHeaderFgColor(`off-white`);
      setHeaderButtonColor({ background: `off-white`, text: `navy` });
    }
  }, [mobileMenuOpen]);

  const links = [
    {
      title: `About`,
      url: `/about`
    },
    {
      title: `Process`,
      url: `/process`
    },
    {
      title: `Services`,
      url: `/services`
    },
    {
      title: `Work`,
      url: `/work`
    },
    {
      title: `Experiments`,
      url: `/experiments`
    }
  ];

  return (
    <header
      className={`${navigating && `opacity-0`} header ${
        cartActive ? `cart-active` : ``
      } w-screen fixed top-0 right-0 left-0 z-30 bg-${headerBgColor} text-${headerFgColor} transition-background`}
    >
      {/* Mobile wordmark + menu bar */}
      <div className="header__touch w-full relative grid items-center justify-between">
        <button
          type="button"
          onClick={() => {
            setCartActive(false);
            setMobileMenuOpen(!mobileMenuOpen);
          }}
          className="grid-end-2 universal-sans b2 text-left"
        >
          {mobileMenuOpen ? `Close` : `Menu`}
        </button>

        <Link
          to="/"
          className="grid-start-3 grid-end-4 relative flex items-center justify-center"
        >
          <Logo
            className={`logo w-full relative block text-${headerFgColor} fill-current`}
          />
        </Link>

        <div className="grid-end-2 overflow-visible">
          <Button
            className="button--header universal-sans b2"
            filled
            color={headerButtonColor.background}
            onClick={() => {
              setMobileMenuOpen(false);
              setCartActive(true);
            }}
          >
            <span className={`text-${headerButtonColor.text}`}>Contact</span>
            {cartLength > 0 && (
              <span
                className={`header__cart-length absolute top-0 z-10 rounded flex items-center justify-center caption universal-sans text-${headerButtonColor.text}`}
              >
                {cartLength}
              </span>
            )}
          </Button>
        </div>
      </div>

      {/*  Desktop links */}
      <nav
        className="desktop-only w-full h-full grid relative items-center"
        onMouseEnter={() => {
          setHeaderHovered(true);
        }}
        onMouseLeave={() => {
          setHeaderHovered(false);
        }}
      >
        <Link to="/" className="grid-end-2 universal-sans b2 fill-current">
          <Logo className={`logo text-${headerFgColor} fill-current`} />
        </Link>

        <div className="grid-start-7 grid-end-5 h-full relative flex items-center">
          <ul className="header__links w-full flex justify-between">
            {links.map((link, index) => {
              const linkKey = `${link.title}-header-link-${index}`;

              return (
                <li key={linkKey}>
                  <Link
                    to={link.url}
                    className={`universal-sans b2 ${pathname === link.url &&
                      `underline`}`}
                  >
                    {link.title}
                  </Link>
                </li>
              );
            })}
          </ul>

          <div
            className={`transition-background-opacity
              ${
                scrollTop > windowWidth * 0.5625 && !headerHovered
                  ? ``
                  : `opacity-0`
              }
            w-full h-full absolute top-0 right-0 bottom-0 left-0 z-10 flex items-center pointer-events-none bg-${headerBgColor}`}
          >
            <p className="universal-sans b2">
              A brand agency that doesn’t do pictures.
            </p>
          </div>
        </div>

        <div className="grid-start-12 grid-end-1 overflow-visible">
          <Button
            className="button--header"
            filled
            color={headerButtonColor.background}
            onClick={() => setCartActive(true)}
          >
            <span className={`text-${headerButtonColor.text}`}>Contact</span>
            {cartLength > 0 && (
              <span
                className={`header__cart-length absolute top-0 z-10 rounded flex items-center justify-center caption universal-sans text-${headerButtonColor.text}`}
              >
                {cartLength}
              </span>
            )}
          </Button>
        </div>
      </nav>
    </header>
  );
};

Header.defaultProps = {
  color: `orange`
};

Header.propTypes = {
  color: PropTypes.string
};

export default Header;
